import { ExternalAccountModel } from 'src/app/organizations/models/external-account.model';
import { UserRoleModel } from 'src/app/auth/models/user-role.model';
import { OrganizationAttributeModel } from './organization-attribute.model';

export class OrganizationModel {
  name: string;
  description: string;
  id: number;
  eid: string;
  // encrypted id associated with the organization
  product_acctid: string;

  user_has_domain_access: boolean;
  email_domain_restriction: boolean;
  user_has_email_domain_access: boolean;
  ip_address_restriction: boolean;
  group_attributes: OrganizationAttributeModel[];
  subscription: {
    paid_through_date: string;
    // ISO date format
    paid_through_date_time: string;
    expired: boolean;
    exists: boolean;
    type: string;
  };
  user_allowances_reached: boolean;
  user_is_subscribed: boolean;
  users_count: number;
  group_logos: {
    error_whitebg: string;
    default: string;
    error_blackbg: string;
    blackbg: string;
    whitebg: string;
  };
  // user's role within the organization
  user_role: UserRoleModel;

  // optionally configured external account provider
  external_account: ExternalAccountModel;
}
